import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    const onClick = (e) => {
      const a = e.target.closest("a[href^='/#'], a[href^='#']");
      if (!a) return;
      const hash = a.getAttribute("href").replace("/", "");
      const el = document.querySelector(hash);
      if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -70 }); }
    };
    document.addEventListener("click", onClick);
    return () => { cancelAnimationFrame(id); document.removeEventListener("click", onClick); lenis.destroy(); };
  }, []);
}
